export default "__VITE_PUBLIC_ASSET__adf618c9__"